/**
 * Shared detector for the backend's transient "scheduler is restarting" 503
 * (api2 SchedulerDrainingException → `{ error: 'scheduler_unavailable', ... }`).
 *
 * That 503 reaches the client via `req`'s `status > 500` path
 * (`parseResponseToError`), which nests the parsed JSON body under
 * `err.bodyData` — NOT top-level `err.error`. Both scheduler error parsers
 * (the hook's `toSchedulerError`, returning a typed Error, and the wizard
 * page's `extractSchedulerError`, returning a display string) must agree on
 * this detection, so it lives here as a single source of truth — previously
 * only the hook handled it, leaving the primary generate path showing the raw
 * HTTP-prefixed message.
 *
 * @returns the friendly message when `err` is the typed draining 503, else null.
 */
export const schedulerUnavailableMessage = (err: unknown): string | null => {
  if (err && typeof err === 'object' && 'bodyData' in err) {
    const bodyData = (
      err as { bodyData?: { error?: string; message?: string } }
    ).bodyData
    if (bodyData?.error === 'scheduler_unavailable') {
      return (
        bodyData.message ??
        'The scheduler is restarting. Please retry in a minute.'
      )
    }
  }
  return null
}
